module.exports = __webpack_public_path__ + "TRUONGlogo.00677041.png";